import React from 'react';
import { withStyles } from '@material-ui/core';
import { default as SwitchMaterialUI } from '@material-ui/core/Switch';
import theme from '@lib/theme';

const styles = {
  colorSwitchBase: {
    color: theme.colors.neutrals.white,
    '&$colorChecked': {
      color: theme.colors.neutrals.white,
      '& + $colorBar': {
        backgroundColor: theme.colors.neutrals.white,
        opacity: 1,
      },
      '& + $track': {
        backgroundColor: theme.colors.primary['blue-2'],
        opacity: 1,
      },
    },
  },
  colorBar: {},
  track: {},
  colorChecked: {},
};

const Switch = props => (
  <SwitchMaterialUI
    name={props.name}
    checked={props.value}
    value={props.value.toString()}
    onChange={props.onChange}
    onBlur={props.onBlur}
    classes={{
      root: props.classes.root,
      track: props.classes.track,
      switchBase: props.classes.colorSwitchBase,
      checked: props.classes.colorChecked,
    }}
    id={props.id}
  />
);

export default withStyles(styles)(Switch);
